package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import dev.lingvo.shared.DeviceClass
import dev.lingvo.site.ds.LMuted
import dev.lingvo.site.i18n.t
import dev.lingvo.site.i18n.tr

/** This output family has a fixed canvas and can use ordinary text/artwork without a capture. */
@Composable
internal fun FeatureGraphicNotice() {
    LMuted(t("app.projects.slug.screenshots.feature_graphic_ui.feature_graphic_1024_500_opaque_rgb", "Feature graphic: 1024 × 500, opaque RGB PNG or JPEG, up to 8 MiB. Assign it to one shot; it can share a screenshot slot. A text or artwork layout needs no capture."))
}

/** Store identifiers remain stable while the newly introduced UI label goes through extraction. */
internal fun screenshotDeviceLabel(device: DeviceClass): String = if (device == DeviceClass.PLAY_FEATURE_GRAPHIC) {
    tr("app.projects.slug.screenshots.feature_graphic_ui.feature_graphic", "Feature graphic")
} else device.displayName
